import * as echarts from "echarts";

export function renderDonutChart(el: HTMLElement, dados: Record<string, number>): echarts.ECharts {
  const chart = echarts.init(el);
  chart.setOption({
    tooltip: { trigger: "item" },
    legend: { bottom: 0 },
    series: [
      {
        type: "pie",
        radius: ["45%", "70%"],
        data: Object.entries(dados).map(([nome, valor]) => ({ name: nome, value: valor })),
      },
    ],
  });
  return chart;
}
